import React from 'react'
import { Button, Dropdown, Menu, Tooltip } from 'antd'
import { DeleteIcon, EditIcon, MenuIcon, RecycleIcon } from './Icons'
import ModalUtil from 'utils/modalUtil';
import DeletePopup from './DeletePopup';
import ResetPasswordPopup from './ResetPasswordPopup';
import _ from 'lodash';
import { hasPermission } from 'utils/authService';


const ActionMenuV2 = ({id = "", items, trigger=['click'], onClick=_.noop, data, disableMenu = false, onVisibleChange = _.noop, byPassConfirmation}) => {

    const onDelete = (item) => {
        ModalUtil.show({
            content: (
                <DeletePopup 
                    title={item.title??"Are you sure?"}
                    promptMessage={item.promptMessage}
                    note={item.note || false}
                    confirmText={item.confirmText??"Delete"}
                    onDelete={onClick}
                    data={{name: item.type, data}}
                    okText={item.okText || "Delete"}
                />
            )
        })
    }

    const onResetPassword = (item) => {
        ModalUtil.show({
            content: (
                <ResetPasswordPopup 
                    promptMessage={item.promptMessage}
                    note={item.note || false}
                    okText={"Yes"}
                    title={"Do you want to reset password?"}
                    onResetPassword={onClick}
                    data={{name: item.type, data}}
                />
            )
        })
    }

    const onActionClick = ({key, domEvent}) => {
        domEvent.stopPropagation();
        const item = items[key];
        switch(item.type){
            case "delete":
                if(byPassConfirmation){
                    onClick('', {name: item.type, data});
                } else {
                    onDelete(item);
                }
                break;
            case "resetPassword":
                onResetPassword(item);
                break;
            default:
                onClick('', {name: item.type, data})
                break;
        }
    }

    const menu = (
        <Menu>
            {items.map((item, index) => {
                if(item.type === "divider"){
                    return <Menu.Divider key={index} />
                }
                const permission = item.permission ? hasPermission(item.permission, item.partialPermissionCheck ?? false) : true;
                const defaultValues = {
                    "edit": {
                        icon: <EditIcon />,
                        text: "Edit"
                    },
                    "delete": {
                        icon: <DeleteIcon className={!permission || item.tooltip === "Coming Soon!" ?  "" : item.disabled ? "disabled" : "danger"}/>,
                        text: "Delete"
                    },
                    "webhook": {
                        icon: <RecycleIcon/>,
                        text: "Webhook"
                    },
                    "resetPassword": {
                        icon: <img src="/images/resetpass.svg" alt="reset" />,
                        text: "resetPassword"
                    }
                }
                // Item name is wrap with span because tooltip is not appearing if the name in wrap with fragment.
                return (
                    <Menu.Item id={`${id}-${item.type}`} onMouseDown={stopPropagation} disabled={!permission || item.disabled} className={`${item.className} action-menu-item`} key={index} icon={item.icon || defaultValues[item.type]?.icon} onClick={onActionClick} >
                        <Tooltip title={!permission ? 'No Access' : item.tooltip}><span>{item.text || defaultValues[item.type].text}</span></Tooltip>
                    </Menu.Item>
                )
            })}
        </Menu>
    )
    return (
        <Dropdown overlay={menu} trigger={trigger} overlayStyle={{minWidth: 150}} disabled={disableMenu} onVisibleChange={onVisibleChange}>
            <Button id={id} type="text" size="small" onClick={stopPropagation} onMouseDown={stopPropagation}><MenuIcon /></Button>
        </Dropdown>
    )
}

const stopPropagation = e => e.stopPropagation();

export default ActionMenuV2;
